<template>
  <div class="wrap" ref="wrapRef" v-loading="loading">
    <div class="top">
      <div class="current_play">
        <span>正在播放：</span>
        <span class="v_name">{{ currentVideo.fileName || "" }}</span>
      </div>
      <div class="opt">
        <div class="comment" @click="showCommemt">
          <Icon icon="solar:chat-round-line-linear" />
          <span>学员评价</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tx_play">
        <video
          id="tx-player"
          style="width: 100%; height: 100%"
          preload="auto"
          playsinline
          webkit-playsinline
        ></video>
      </div>
      <div class="handle">
        <div class="shrink_icon" @click="togglehandle()">
          <Icon :icon="iconStr" />
        </div>
        <div class="tab">
          <el-segmented
            size="large"
            v-model="activeTab"
            :options="tabOptions"
            block
            @change="changeTab"
          ></el-segmented>
        </div>
        <div class="catalogue_wrap" v-if="activeTab == '目录'">
          <el-scrollbar v-if="studyInfo.videoVos?.length">
            <div
              class="catalogue_item"
              v-for="(item, index) in studyInfo.videoVos"
              :key="index"
            >
              <h2
                @click="changeVideo(item)"
                :title="item.fileName"
                :class="{ active: currentWatchFileId == item.fileId }"
              >
                {{ item.fileName }}
              </h2>
              <div class="teacherName">
                <span>{{ item.teacherName || "-" }}</span>
                <span
                  >视频时长：{{
                    formateVideoDuration(item.videoDuration)
                  }}</span
                >
              </div>
              <div class="videoWatchFlag">
                <template v-if="item?.isCurrentWatch == 1">
                  <el-text type="primary">
                    正在观看
                    <Icon icon="carbon:video-chat" />
                  </el-text>
                </template>
                <template v-else>
                  <el-text v-if="item?.videoWatchFlag == 0" type="info"
                    >未观看</el-text
                  >
                  <el-text v-if="item?.videoWatchFlag == 1" type="primary">
                    上次观看时间 : {{ formateVideoDuration(item.progress) }}
                  </el-text>
                  <el-text v-if="item?.videoWatchFlag == 2" type="success"
                    >已观看</el-text
                  >
                </template>
              </div>
              <el-divider />
            </div>
          </el-scrollbar>
          <el-empty v-else description="暂无数据" />
        </div>
        <div class="note_wrap" v-if="activeTab == '笔记'">
          <div class="note_tex">
            <el-input
              v-model="note"
              :rows="4"
              type="textarea"
              maxlength="500"
              show-word-limit
              placeholder="输入对此节的学习笔记，课后复习巩固..."
            />
            <p class="opt">
              <span class="tip">不能少于12个字</span>
              <el-button type="primary" size="small" @click="saveNote">记笔记</el-button>
            </p>
            <p class="title">笔记内容</p>
          </div>
          <ul class="note_list">
              <li v-for="(n,index) in noteList" :key="index">
                  <div class="icon">
                      <Icon icon="solar:pin-outline"  />
                      <el-tag type="success" @click="setProgress(n.progress)">
                        {{ formateVideoDuration(n.progress) }}
                      </el-tag>
                  </div>
                  <div class="note">{{ n.notes }}</div>
              </li>
          </ul>
        </div>
        <div class="evaluate_wrap" v-if="activeTab == '学员评价'">
          <el-empty v-if="!commentInfo.id" description="暂无评价" />
          <div v-else>
            <h2>我的评价反馈：</h2>
            <div class="c_main">
              <p>课程质量：{{ renderComment(commentInfo.quality) }}</p>
              <p>老师讲法：{{ renderComment(commentInfo.teach) }}</p>
              <p>我对这节课的感受：{{ renderComment(commentInfo.feel) }}</p>
              <p>其他描述：{{ commentInfo.comment }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <commentComp
      v-model:show="commentHandler.show"
      :fileId="commentHandler.fileId"
      :stuId="commentHandler.stuId"
      :subjectId="commentHandler.subjectId"
      @success="addCommentSuccess"
    />
  </div>
</template>

<script setup>
import { createPolling,VideoHandleTimer } from '@/utils/playHelp'
import { TXLicenseUrl } from "@/constants/index";
import {
  getPlayTokenApi,
  getCommentByRequestApi,
  saveVideoLearningApi,
  noteSaveApi,
  noteListApi
} from "@/api/userPlay/index";
import { ElMessage } from "element-plus";
import { getChapterStudentStudyDataApi } from "@/api/courseUser/index";
import commentComp from "./components/comment.vue";
import useUserStore from "@/store/modules/user";
import { usePlayStore } from '@/store/modules/play';
const playStore = usePlayStore()
const { isMoniLogin } = storeToRefs(playStore)
const userStore = useUserStore();
const { userInfo } = storeToRefs(userStore);
const route = useRoute();
import TCPlayer from "tcplayer.js";
import { Icon } from "@iconify/vue";
import { storeToRefs } from 'pinia';
import { createPlugins, tcplayerTip } from '@/utils/tcplayerOptions';
const wrapRef = ref(null)
const handleWidth = ref("280px");
const iconStr = ref("ri:arrow-right-double-fill");
const togglehandle = () => {
  if (handleWidth.value == "280px") {
    handleWidth.value = "0px";
    iconStr.value = "ri:arrow-left-double-fill";
  } else {
    handleWidth.value = "280px";
    iconStr.value = "ri:arrow-right-double-fill";
  }
};
const loading = ref(false);
const activeTab = ref("目录");
const tabOptions = ["目录", "笔记", "学员评价"];
const note = ref("");
let params = {
  orderDetailId: "",
  objectivesId: "",
};
const studyInfo = ref([]);


const currentVideo = ref({}) //当前播放视频对象
const currentWatchFileId = ref(""); //当前播放视频id
let videoTimer = null; //记录操作时长
let infinitePolling = null; //轮询保存学习记录对象
//获取学习信息
const getChapterStudentStudyData = async (init=false) => {
  const { data } = await getChapterStudentStudyDataApi(
    params.orderDetailId,
    params.objectivesId
  );
  if (data) {
    studyInfo.value = data;
    //如果有取这个,初始化请求
    if(init){
      if (data.currentWatchFileId) {
        currentWatchFileId.value = data.currentWatchFileId;
        currentVideo.value = data.videoVos.find(it => it.fileId == data.currentWatchFileId)
      } else {
        if (data.videoVos?.length) {
          currentWatchFileId.value = data.videoVos[0].fileId;
          currentVideo.value = data.videoVos[0];
        }
      }
    }
  }
};
const commentOptions = [
  { label: "非常差", value: 1 },
  { label: "差", value: 2 },
  { label: "正常", value: 3 },
  { label: "好", value: 4 },
  { label: "非常好", value: 5 },
];
const renderComment = (val) => {
  const obj = commentOptions.find((v) => v.value == val);
  return obj.label;
};


const commentInfo = ref({});
//评价列表
const getCommentList = () => {
  getCommentByRequestApi({
    fileId: currentWatchFileId.value,
    subjectId: studyInfo.value.subjectId,
    stuId: userInfo.value.crmZId,
  }).then((res) => {
    commentInfo.value = res.data || {};
  });
};
const changeTab = (v) => {
  if (v == "学员评价") {
    getCommentList();
  }
  if(v == "笔记"){
    getNoteList()
  }
};
const addCommentSuccess = () => {
  if (activeTab.value == "学员评价") {
    getCommentList();
  }
};
const noteList = ref([])
const getNoteList = async ()=>{
    const res = await noteListApi({
        fileId: currentVideo.value.fileId,
        subjectId: currentVideo.value.subjectId,
        stuId: userInfo.value.crmZId,
    })
    if(res.code == 200){
      noteList.value = res.data || [];
    }
}
//保存笔记
const saveNote = async ()=>{
    if(!note.value){
        return ElMessage.warning({
                  message: '请输入笔记再提交',
                })
    }
    const params = {
        fileId: currentVideo.value.fileId,
        subjectId: currentVideo.value.subjectId,
        stuId: userInfo.value.crmZId,
        progress:parseInt(tPlayerInstance.currentTime()),
        notes:note.value
    }
    const res = await noteSaveApi(params)
    if(res.code == 200){
        note.value = '';
        getNoteList()
    }
}
//时间格式化
function formateVideoDuration(time) {
  if (!time) return "-";
  const h = parseInt(time / 3600);
  const minute = parseInt((time / 60) % 60);
  const second = Math.ceil(time % 60);

  const hours = h < 10 ? "0" + h : h;
  const formatSecond = second > 59 ? 59 : second;
  return `${hours > 0 ? `${hours}:` : "00:"}${
    minute < 10 ? "0" + minute : minute
  }:${formatSecond < 10 ? "0" + formatSecond : formatSecond}`;
}
//播放器实例
let tPlayerInstance = null;
//正在播放
let isTPlay = false;
//鉴权信息
const playTokenInfo = ref({});
const tcPalyEvent = () => {
  if(tPlayerInstance){
      tPlayerInstance.on("loadstart", () => {
          //如果有进度，设置进度
          setProgress(currentVideo.value.progress)
      });
      tPlayerInstance.on('loadedmetadata', () => {
        tcplayerTip.init(tPlayerInstance);
      });
      //播放就开始
      tPlayerInstance.on("play", () => {
          //开始轮训
          if(infinitePolling){
            infinitePolling.stop()
          }
          startPolling()
      });
      // 腾讯视频播放完毕
      tPlayerInstance.on("ended", async () => {
          isTPlay = false;
          saveVideoLearning()
          if(videoTimer) videoTimer.stop()
          if(infinitePolling) infinitePolling.stop()
      });

      // 腾讯视频暂停
      tPlayerInstance.on("pause", async () => {
        isTPlay = false;
        saveVideoLearning()
        if(videoTimer) videoTimer.stop()
        if(infinitePolling){
          infinitePolling.stop()
        }
      });

      // 腾讯播放视频
      tPlayerInstance.on("playing", () => {
        tcplayerTip.clear(tPlayerInstance);
        if(!videoTimer){
          videoTimer = new VideoHandleTimer();
          videoTimer.start()
        }
        if(videoTimer) videoTimer.start()
        if(infinitePolling){
          infinitePolling.stop()
        }
        startPolling()
        isTPlay = true;
      });
      tPlayerInstance.on("error", () => {
          if(videoTimer) videoTimer.stop()
          if(infinitePolling){
            infinitePolling.stop()
          }
          isTPlay = false;
      });
  }
};
const setProgress = (progress) =>{
      if(progress) {
          tPlayerInstance&&tPlayerInstance.currentTime(progress)
      }
}
//保存学习记录
let currentVideoId = ''
const saveVideoLearning = async () =>{
    if(isMoniLogin.value) return;
    let duration = 1;
    if(videoTimer) duration = videoTimer.getTime()
    let params = {
        id: currentVideoId,
        fileId: currentVideo.value.fileId,
        orderId: currentVideo.value.orderId,
        subjectId: currentVideo.value.subjectId,
        source: 1,
        duration: duration,
        progress: parseInt(tPlayerInstance.currentTime()),
        isFinished:(tPlayerInstance.duration() - tPlayerInstance.currentTime()) < 3 ? 1 : 0,
        objectivesId: studyInfo.value.id
    }
    try {
      const res = await saveVideoLearningApi(params)
      currentVideoId = res.msg
      return res;
    } catch (error) {
      showMsg(error)
    }
}
//开始轮训
const startPolling = () =>{
  infinitePolling = createPolling({
        task:saveVideoLearning,
        immediate:false,
        condition: (res) => {
          return true
        },
        interval: 30000,
        maxAttempts: Infinity, // 无限轮询
        onSuccess: (result) => console.log('任务完成:', result),
        onComplete:() =>  console.log('轮训结束')
    });
}
function handleKeyDown(ev) {
  console.log(ev.which)
  switch (ev.which) {
    case 32: // 空格键
      if (isTPlay) {
        tPlayerInstance.pause()
      } else {
        tPlayerInstance.play()
      }
      break
    case 39: // 右键(快进)
      const next = tPlayerInstance.currentTime() + 10
      const timeN = next >= tPlayerInstance.duration() ? tPlayerInstance.duration() : next
      tPlayerInstance.currentTime(timeN)
      showMsg('播放进度：' + formateVideoDuration(timeN))
      break
    case 37: // 左键(快退)
      const prev = tPlayerInstance.currentTime() - 10
      const timeP = prev <= 0 ? 0 : prev
      tPlayerInstance.currentTime(timeP)
      showMsg('播放进度：' + formateVideoDuration(timeP))
      break
    case 38: // 上
      const upV = parseFloat((tPlayerInstance.volume() + 0.1).toFixed(2))
      const volumeM = upV >= 1 ? 1 : upV
      tPlayerInstance.volume(volumeM)
      showMsg('音量：' + (volumeM * 100).toFixed(0) + '%')
      break
    case 40: // 下
      const downV = parseFloat((tPlayerInstance.volume() - 0.1).toFixed(2))
      const volumeD = downV <= 0 ? 0 : downV
      tPlayerInstance.volume(volumeD)
      showMsg('音量：' + (volumeD * 100).toFixed(0) + '%')
      break
  }
}
function showMsg(msg) {
  ElMessage.closeAll();
  ElMessage.info({
    appendTo: '#tx-player',
    message: msg,
  })
}
//点播初始化
const initDbPlay = async (autoplay, data)=>{
  try {
    if (!data || !data.token) {
      ElMessage({
        type: "error",
        message: "腾讯视频鉴权失败",
      });
      return
    }
    playTokenInfo.value = data;
    if(tPlayerInstance){
        tPlayerInstance.loadVideoByID({
          fileID: data.basicInfo.vid || "",
          appID: data.subAppId,
          psign: data.token,
        });
        if(autoplay){
            //开始计时
            if(!videoTimer){
              videoTimer = new VideoHandleTimer();
              videoTimer.start()
            }
            setTimeout(()=>{
                tPlayerInstance.play()
            },1500)
        }
        return;
    }
    tPlayerInstance = TCPlayer("tx-player", {
        fileID: data.basicInfo.vid || "",
        appID: data.subAppId,
        psign: data.token || "",
        licenseUrl: TXLicenseUrl,
        language: "ZH",
        autoplay: autoplay,
        width: "100%",
        height: "100%",
        playbackRates: [0.8, 1, 1.2, 1.5,1.8, 2],
        languages: {
          ZH: {
            "360P": "流畅",
            高清: "高清",
            auto: "标清",
          },
        },
        plugins: createPlugins()
    });

    tPlayerInstance.on('loadedmetadata', () => {
      tcplayerTip.init(tPlayerInstance);
    });

    tPlayerInstance.on('playing', () => {
      tcplayerTip.clear(tPlayerInstance);
    });
  } catch (error) {

  }
}
//初始化直播回放播放器
const initZbPlay = async (autoplay, data)=>{
  try {
      if (!data || !data.url) {
        ElMessage({
          type: "error",
          message: "腾讯视频鉴权失败",
        });
        return
      }
      playTokenInfo.value = data;
      if(tPlayerInstance){
          tPlayerInstance.src( data.url)
          if(autoplay){
            //开始计时
            if(!videoTimer){
              videoTimer = new VideoHandleTimer();
              videoTimer.start()
            }
            setTimeout(()=>{
                tPlayerInstance.play()
            },1500)
          }
          return
      }
      tPlayerInstance = TCPlayer("tx-player", {
          sources: [{
            src: data.url, // 播放地址
          }],
          licenseUrl: TXLicenseUrl,
          language: "ZH",
          autoplay:autoplay,
          width: "100%",
          height: "100%",
          playbackRates: [0.8, 1, 1.2, 1.5,1.8, 2],
          languages: {
            ZH: {
              "360P": "流畅",
              高清: "高清",
              auto: "标清",
            },
          },
          plugins: createPlugins()
      });
  } catch (error) {

  }
}
//初始化播放器
const initTCPlay = async () => {
  try {
      const { data } = await getPlayTokenApi(currentWatchFileId.value);

      if(data.videoType == '直播'|| data.videoType == '直播回放'){
        await initZbPlay(false, data)
      }else if(data.videoType == '录播'){
        await initDbPlay(false, data)
      }else{
        ElMessage({
          type: "error",
          message: "视频参数有误！",
        });
        return
      }
      //监听事件
      tcPalyEvent()

  } catch (error) {

  }
};

//切换视频
const changeVideo = async (item) => {
  //保存上个视频记录
  await saveVideoLearning()

  currentWatchFileId.value = item.fileId;
  currentVideo.value = {...item}

  const { data } = await getPlayTokenApi(currentWatchFileId.value);
  //刷新目录列表
  if(data.videoType == '直播'|| data.videoType == '直播回放'){
    if(!videoTimer){
      videoTimer = new VideoHandleTimer();
      videoTimer.start()
    }
    await initZbPlay(true, data)
  }
  if(data.videoType == '录播'){
    if(!videoTimer){
      videoTimer = new VideoHandleTimer();
      videoTimer.start()
    }
    await initDbPlay(true, data)
  }
  //保存当前记录
  await saveVideoLearning()

  await getChapterStudentStudyData(false)
};
const commentHandler = reactive({
  show: false,
  fileId: currentWatchFileId.value,
  stuId: userInfo.value.crmZId,
  subjectId: studyInfo.value.subjectId,
});
const showCommemt = () => {
  commentHandler.fileId = currentWatchFileId.value;
  commentHandler.stuId = userInfo.value.crmZId;
  commentHandler.subjectId = studyInfo.value.subjectId;
  commentHandler.show = true;
};
const init = async () => {
  loading.value = true;
  const query = route.query;
  try {
    if (
      Reflect.has(query, "orderDetailId") &&
      Reflect.has(query, "objectivesId")
    ) {
      params.orderDetailId = query.orderDetailId;
      params.objectivesId = query.objectivesId;
      await getChapterStudentStudyData(true);
      await initTCPlay()

    } else {
      ElMessage({
        type: "error",
        message: "缺少必要参数",
      });
    }
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};
onMounted(async () => {
  init();
  window.addEventListener('keydown', handleKeyDown)
});

onUnmounted(()=>{
    if(videoTimer) videoTimer.stop()
    if(infinitePolling) infinitePolling.stop()
    if(tPlayerInstance) tPlayerInstance.dispose()
    window.removeEventListener('keydown', handleKeyDown)
})
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  background-color: #000;
  $topHeight: 50px;
  .top {
    width: 100%;
    height: $topHeight;
    box-sizing: border-box;
    padding: 8px 16px;
    background-color: #363636;
    display: flex;
    justify-content: space-between;
    .current_play {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
    }
    .opt {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #fff;
      .comment {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
    .v_name {
      font-size: 18px;
      font-weight: bold;
      color: var(--el-color-primary);
    }
  }
  .content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: calc(100% - $topHeight);
    .handle {
      background-color: #fff;
      width: v-bind(handleWidth);
      height: 100%;
      position: relative;
      border-left: 1px solid #e1dfdf;
      box-sizing: border-box;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      .shrink_icon {
        cursor: pointer;
        width: 20px;
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 18px;
        position: absolute;
        overflow: hidden;
        border-radius: 9px 0 0 9px;
        background-color: var(--el-color-primary);
        box-shadow: var(--el-box-shadow-dark);
        left: -20px;
        top: 0;
        bottom: 0;
        margin: auto;
        color: #fff;
      }
      .tab {
        width: 100%;
        height: 40px;
      }
      .catalogue_wrap {
        width: 100%;
        padding: 8px 12px;
        box-sizing: border-box;
        height: calc(100% - 40px);
        overflow-y:auto;
        .catalogue_item {
          :deep(.el-divider--horizontal) {
            margin: 16px 0;
          }
          h2 {
            font-weight: bold;
            font-size: 14px;
            line-height: 18px;
            cursor: pointer;
            &:hover {
              color: var(--el-color-primary);
            }
            &.active {
              color: var(--el-color-primary);
            }
          }
          .teacherName {
            display: flex;
            font-size: 14px;
            color: #445;
            margin-top: 16px;
            span:nth-child(2) {
              margin-left: 16px;
            }
          }
          .videoWatchFlag {
            margin-top: 14px;
            --el-font-size-base: 12px;
          }
        }
      }
      .note_wrap {
        width: 100%;
        height: calc(100% - 40px);
        display: flex;
        overflow-y:auto;
        flex-direction: column;
        padding: 4px;
        box-sizing: border-box;
        .opt {
          height: 48px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tip {
            font-size: 14px;
            color: #626060;
          }
        }
        .title{
            font-size: 16px;
            color: #626060;
            height: 36px;
            line-height: 36px;
        }
        .note_list{
          width: 100%;
          height: calc(100% - 48px - 94px - 36px);
          overflow: auto;
          li{
            display: flex;
            align-items: start;
            border-bottom: 1px solid #e0dddd;
            padding: 16px 0;
            box-sizing: border-box;
            .icon{
              display: flex;
              align-items: center;
              .el-tag{
                margin-left: 4px;
                cursor: pointer;
              }
            }
            .note{
              font-size: 12px;
              flex:1;
              padding: 0 4px;
              box-sizing: border-box;
              color:#444;
            }
          }
        }
      }
      .evaluate_wrap {
        padding: 8px;
        box-sizing: border-box;
        overflow-y:auto;
        h2 {
          color: #333;
          font-size: 16px;
        }
        .c_main {
          padding-top: 8px;
          padding-left: 16px;
          box-sizing: border-box;
          p {
            line-height: 24px;
            font-size: 14px;
          }
        }
      }
    }
    .tx_play {
      width: calc(100% - v-bind(handleWidth) - 20px);
      height: 100%;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      background-color: #000;
    }
  }
}
</style>
